import React from 'react';
import './LessonThermometer.css';

// A vertical "thermometer" lesson progress indicator pinned to the left edge.
// It fills smoothly from the bottom as the student moves through the steps
// (no tick marks). Decorative (pointer-events: none) so it never blocks taps.
export default function LessonThermometer({ current, total }) {
  const safeTotal = total > 0 ? total : 1;
  const pct = Math.min(100, Math.max(0, (current / safeTotal) * 100));

  return (
    <div
      className="lesson-thermometer"
      role="progressbar"
      aria-label={`Step ${current} of ${total}`}
      aria-valuemin={1}
      aria-valuenow={current}
      aria-valuemax={total}
    >
      <span className="lesson-thermometer__label">{current}/{total}</span>
      <div className="lesson-thermometer__track">
        <div className="lesson-thermometer__fill" style={{ height: `${pct}%` }} />
      </div>
      <span className="lesson-thermometer__bulb" />
    </div>
  );
}
